function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import merge from 'lodash/merge';
import sendBeacon from '../utils/send-beacon';
import retrieveUserToken from '../utils/user-token';
var timeout = 500;
export default (_ref => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints;
  return (_ref2, _ref3) => {
    var analyticMetricType = _ref2.analyticMetricType,
      data = _ref2.data;
    var dateCreated = _ref3.dateCreated;
    var getAbsoluteUrl = shared.getAbsoluteUrl;
    var _endpoints$metrics = endpoints.metrics,
      metrics = _endpoints$metrics === void 0 ? '/wsvc/analytics/metricsu' : _endpoints$metrics;
    var metricEndpoint = getAbsoluteUrl(metrics);
    var payload = {
      analyticMetricType,
      dateCreated: dateCreated.toISOString(),
      data: _objectSpread(_objectSpread({}, data), {}, {
        userToken: retrieveUserToken()
      })
    };
    if (navigator && navigator.userAgent) {
      merge(payload, {
        data: {
          userAgent: navigator.userAgent
        }
      });
    }
    if (window && window.location) {
      merge(payload, {
        data: {
          url: window.location.href
        }
      });
    }
    if (document && document.referrer) {
      merge(payload, {
        data: {
          referrer: document.referrer
        }
      });
    }
    var encodedPayload = encodeURIComponent(JSON.stringify(payload));
    sendBeacon("".concat(metricEndpoint, "?j=").concat(encodedPayload), {
      timeout,
      method: 'POST'
    });
  };
});